import { useQuery } from '@tanstack/react-query'
import { useTenantProductType } from '../../hooks/useTenantProductType'
import { tenantSettingsService } from '../../services/tenantSettingsService'
import { isLeaveModuleEnabled, readLeaveModuleDevOverride } from './productModule'

export function useLeaveModuleEnabled() {
  const product = useTenantProductType()
  const settings = useQuery({
    queryKey: ['tenant-settings'],
    queryFn: () => tenantSettingsService.getCurrent(),
    staleTime: 60_000,
  })

  const enabled = isLeaveModuleEnabled({
    productType: product.productType,
    tenantEnabled: settings.data?.modules?.leave === true,
    devOverride: readLeaveModuleDevOverride(),
  })

  return {
    enabled,
    isLoading: product.isLoading || settings.isLoading,
  }
}
